import styles from './App.module.css';
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Footer from './components/Footer';
import { ReactComponent as Arrow } from './components/svg/arrow.svg';

function App() {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
        section.scrollIntoView({ behavior: "smooth" });
    }
};
  return (
    <div className="App">
      <Header />
      <About />
      <Projects />
      <Footer />
      <Arrow className={styles.arrow} onClick={() => scrollToSection("header")}/>
    </div>
    
  );
}

export default App;
